import { useQueryClient } from '@tanstack/react-query';

import { useQuery } from '@hooks/reactQuery';

import { getActiveAlarmsFlexidas } from '@api/alarmHistory';

import { extractQueryParams } from '@utils/common';
import { formatDate } from '@utils/kpi-utils/date';

import { IActiveAlarmsFlexidas } from '@interfaces/alarms/alarm';
import { IAlarmByVendor } from '@interfaces/alarms/dto/alarmsDTO';

import { EVendorsValues } from '@enums/common';

import { formatTemplateDefault } from '@constants/common';
import { ACTIVE_ALARMS_FLEXIDAS } from '@constants/queryKeys';

interface IUseQueryActiveAlarmsFlexidasReturn {
	data: IActiveAlarmsFlexidas[];
	countOfRecords: number;
	isLoading: boolean;
	invalidateQuery: () => void;
}

export const useQueryActiveAlarmsFlexidas = (params: IAlarmByVendor): IUseQueryActiveAlarmsFlexidasReturn => {
	const queryClient = useQueryClient();

	const isEnabled = params.vendor === EVendorsValues.flexidas;
	const { isEnabled: isEnabledTab, ...restParams } = params;

	const { fromDate, toDate } = params;

	const dto = {
		...restParams,
		fromText: fromDate ? formatDate(fromDate, formatTemplateDefault) : null,
		toText: toDate ? formatDate(toDate, formatTemplateDefault) : null,
	};

	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [ACTIVE_ALARMS_FLEXIDAS, dto],
		queryFn: extractQueryParams(getActiveAlarmsFlexidas),
		enabled: [isEnabled, isEnabledTab],
		refetchOnWindowFocus: false,
	});

	const invalidateQuery = () => {
		return [queryClient.invalidateQueries([ACTIVE_ALARMS_FLEXIDAS])];
	};

	return {
		isLoading: isInitialLoading,
		data: data?.items || [],
		countOfRecords: data?.count || 0,
		invalidateQuery,
	};
};
